/* unplugin-vue-components disabled */import { render } from "./UserItemList.vue?vue&type=template&id=486f4538&scoped=true&ts=true"
import script from "./UserItemList.vue?vue&type=script&lang=ts"
export * from "./UserItemList.vue?vue&type=script&lang=ts"

import "./UserItemList.vue?vue&type=style&index=0&id=486f4538&lang=less&scoped=true"

import exportComponent from "/work/release/ug-fe-contest-student/node_modules/.pnpm/vue-loader@16.7.0_@vue+compiler-sfc@3.2.23_vue@3.2.23_webpack@4.46.0/node_modules/vue-loader/dist/exportHelper.js"
export default /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-486f4538"]])